const Apexchart = {
  settings(id = "apexchart", showToolbar = true) {
    return {
      chart: {
        id: id,
        type:"line",
        toolbar: {
          show: showToolbar, 
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
          },
          autoSelected: 'zoom'
        },
        animations: {
          enabled: false,
          animateGradually: {
            enabled: false
          },
          dynamicAnimation: {
            enabled: false
          }
        }
      },
      theme: {
        palette: "palette3"
      },
      xaxis: {
        type: "datetime"
  
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        curve: "straight",
        lineCap: "butt",
        width: 2,
        dashArray: 0
      },
      tooltip: {
        x: { format: "dd MMM HH:mm" }
      }
    } 
  }   
}


export default Apexchart;